<template>
  <div>
    <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      :interval="100000"
      img-height="1000"
      indicators
    >
      <template v-for="(item,index) in dataList">
        <b-carousel-slide v-bind:key="index"
          :caption="item.caption"
          img-height="1000"
          :img-src="item.img"
        >
          <router-link tag="div" class="font-14 cursor-pointer common-line-height-2"
                       :to="{path: item.url}">{{item.describe}}</router-link>
        </b-carousel-slide>
      </template>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'CommSwipe',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style>
  @media (min-width: 992px) {
    #carousel-fade img {
      height: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CommSwipe.vue